function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("style", null, "\n      .icon_menu_configuracoes_a{fill:#fff;stroke:#707070;}\n      .icon_menu_configuracoes_b{clip-path:url(#icon_menu_configuracoes_a);}\n      .icon_menu_configuracoes_c{fill:#cfd8dc;}\n      .icon_menu_configuracoes_d{fill:#b4bcc0;}\n      .icon_menu_configuracoes_e{fill:#90a4ae;}\n      .icon_menu_configuracoes_f{fill:#607d8b;}\n      .icon_menu_configuracoes_g{fill:#7d8f97;}\n      .icon_menu_configuracoes_h{fill:#546d79;}\n    "), React.createElement("clipPath", {
  id: "icon_menu_configuracoes_a"
}, React.createElement("rect", {
  className: "icon_menu_configuracoes_a",
  width: 19,
  height: 19,
  transform: "translate(1800 1165)"
})));

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  className: "icon_menu_configuracoes_b",
  transform: "translate(-1800 -1165)"
}, React.createElement("g", {
  transform: "translate(1800 1165)"
}, React.createElement("path", {
  className: "icon_menu_configuracoes_c",
  d: "M16.328,10.292H10.49a.792.792,0,1,1,0-1.583h5.839a.792.792,0,1,1,0,1.583Z"
}), React.createElement("path", {
  className: "icon_menu_configuracoes_d",
  d: "M17.12,9.5H9.7a.792.792,0,0,0,.792.792h5.839A.792.792,0,0,0,17.12,9.5Z"
}), React.createElement("path", {
  className: "icon_menu_configuracoes_c",
  d: "M6.789,3.183l2.9,5.064a.792.792,0,0,1-1.374.788l-2.9-5.064a.792.792,0,1,1,1.374-.788Z"
}), React.createElement("path", {
  className: "icon_menu_configuracoes_d",
  d: "M5.709,2.89,9.4,9.328a.792.792,0,0,0,.293-1.081L6.789,3.183A.792.792,0,0,0,5.709,2.89Z"
}), React.createElement("path", {
  className: "icon_menu_configuracoes_c",
  d: "M5.369,14.994l2.948-5.04a.792.792,0,0,1,1.366.8l-2.948,5.04a.792.792,0,1,1-1.366-.8Z"
}), React.createElement("path", {
  className: "icon_menu_configuracoes_d",
  d: "M5.653,16.077,9.4,9.671a.792.792,0,0,0-1.083.283l-2.947,5.04a.792.792,0,0,0,.283,1.083Z"
}), React.createElement("path", {
  className: "icon_menu_configuracoes_e",
  d: "M18.208,7.917h-.951a7.774,7.774,0,0,0-.245-.922l.825-.477a.785.785,0,0,0,.287-1.077L17.331,4.06a.791.791,0,0,0-1.077-.286l-.83.477a7.639,7.639,0,0,0-.674-.675l.475-.826a.792.792,0,0,0-.287-1.081L13.564.878a.786.786,0,0,0-1.081.286l-.477.823a7.774,7.774,0,0,0-.922-.245V.792A.783.783,0,0,0,10.292,0H8.708a.783.783,0,0,0-.792.792v.951a7.774,7.774,0,0,0-.922.245l-.477-.825A.786.786,0,0,0,5.44.876l-1.381.793a.79.79,0,0,0-.286,1.077l.477.83a7.639,7.639,0,0,0-.675.674l-.826-.475a.791.791,0,0,0-1.081.287L.877,5.437a.786.786,0,0,0,.286,1.081l.824.477a7.774,7.774,0,0,0-.245.922H.792A.783.783,0,0,0,0,8.708v1.583a.783.783,0,0,0,.792.792h.951a7.815,7.815,0,0,0,.245.922l-.825.477A.785.785,0,0,0,.876,13.56l.793,1.381a.79.79,0,0,0,1.077.286l.83-.477a7.638,7.638,0,0,0,.674.674l-.475.826a.793.793,0,0,0,.287,1.081l1.375.79a.786.786,0,0,0,1.08-.287l.477-.824a7.646,7.646,0,0,0,.923.246v.951A.783.783,0,0,0,8.708,19h1.583a.783.783,0,0,0,.792-.792v-.951a7.942,7.942,0,0,0,.923-.245l.477.825a.786.786,0,0,0,1.077.287l1.381-.793a.79.79,0,0,0,.286-1.077l-.477-.829a7.638,7.638,0,0,0,.674-.674l.827.475a.793.793,0,0,0,1.081-.287l.79-1.375a.786.786,0,0,0-.286-1.081l-.824-.477a7.815,7.815,0,0,0,.245-.922h.95A.783.783,0,0,0,19,10.292V8.708a.783.783,0,0,0-.792-.792ZM9.5,15.042A5.542,5.542,0,1,1,15.042,9.5,5.548,5.548,0,0,1,9.5,15.042Z"
}), React.createElement("path", {
  className: "icon_menu_configuracoes_f",
  d: "M9.5,7.521A1.979,1.979,0,1,0,11.479,9.5,1.981,1.981,0,0,0,9.5,7.521Z"
}), React.createElement("path", {
  className: "icon_menu_configuracoes_g",
  d: "M9.5,0H8.708a.783.783,0,0,0-.792.792v.951a7.774,7.774,0,0,0-.922.245l-.477-.825A.785.785,0,0,0,5.44.876l-1.381.792a.79.79,0,0,0-.286,1.077l.477.83a7.639,7.639,0,0,0-.675.674l-.827-.475a.782.782,0,0,0-.4-.108.791.791,0,0,0-.685.394L.877,5.437a.786.786,0,0,0,.286,1.081l.824.477a7.774,7.774,0,0,0-.245.922H.792A.783.783,0,0,0,0,8.708v1.583a.783.783,0,0,0,.792.792h.951a7.815,7.815,0,0,0,.245.922l-.825.477A.785.785,0,0,0,.876,13.56l.793,1.381a.793.793,0,0,0,.684.392.777.777,0,0,0,.393-.106l.83-.477a7.638,7.638,0,0,0,.674.674l-.475.826a.793.793,0,0,0,.287,1.081l1.375.79a.8.8,0,0,0,.4.108.787.787,0,0,0,.681-.4l.477-.824a7.646,7.646,0,0,0,.923.246v.951A.783.783,0,0,0,8.708,19H9.5V15.042a5.542,5.542,0,1,1,0-11.083Z"
}), React.createElement("path", {
  className: "icon_menu_configuracoes_h",
  d: "M9.5,7.521a1.979,1.979,0,0,0,0,3.958Z"
})));

var SvgConfiguracoes = function SvgConfiguracoes(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgConfiguracoes, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/configuracoes.d2581a8b.svg";
export { ForwardRef as ReactComponent };